module.exports = __webpack_public_path__ + "static/media/desktop-movie-sm.8688b03f.png";


//////////////////
// WEBPACK FOOTER
// ./src/desktop-movie-sm.png
// module id = 27
// module chunks = 0